import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { TextBox, TextBoxProps } from "../../core/components/textBox";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DropDownList } from "../../core/components/dropDownList";
import { DialogHelper } from "../../core/util/dialogHelper";
import { IsNumericTextBox } from "../../core/components/isNumericTextBox";
import { NotificationHelper } from "../../core/util/notificationHelper";
import EditTranslations from "../editTranslations";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react"
export default class EditMachineGroup extends React.Component<EditMachineGroupProps, EditMachineGroupState> {
    private _factory = ComponentHelper.createFactory();
    private _editTranslationsRef: EditTranslations = null;
    private _nextMaGrNr: number;
    private _machineDependence: boolean;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this._checkEntity()) {                        
                        this._saveEntity();
                    } else {
                        DialogHelper.alert(this.props.context.translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }                    
                },
                primary: true
            }
        ],
        afterClose: () => {
            this._closeDialog();
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this.state = { gridData: [], dialogOpen: false, selectedEntity: null };    
    }

    private _checkEntity = () => {
        if (!Helper.hasValue(this.state.selectedEntity.Id) || (!Helper.isNumber(this.state.selectedEntity.Id))) {
            return false;
        } else if (this._machineDependence && !Helper.hasValue(this.state.selectedEntity.ReferenceToMainGroup)) {
            return false;
        } else {
            return true;
        }
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={true} >
                    <FullHeightContainer>
                        {this._createNumberTextBox()}
                        {this._createNameTextBox()}
                        {this._createTranslationLabel()}
                        {this._createDropDownList()}
                    </FullHeightContainer>
                    <EditTranslations
                        ref={(r) => this._editTranslationsRef = r}
                        label={Config.translations.editLabel}
                        saveGerman={(value: string) => {
                            let newEntity = this.state.selectedEntity;
                            newEntity.GermanName = value;
                            this.setState({ selectedEntity: newEntity });
                        }}
                    />
                </Dialog>
            </div>
        );
    }

    private _createNumberTextBox = () => {
        let props = this._factory.getDefaultNumericTextBoxProps();
        props.disabled = !this.state.selectedEntity.IsNew;
        props.field.spinners = false;
        props.value = Helper.getValueOrDefault(this.state.selectedEntity.Id, "0");
        props.onChange = (field: { model: string, name: string }, value: any) => {
            let newEntity = this.state.selectedEntity;
            newEntity.Id = Math.round(value);
            this.setState({ selectedEntity: newEntity });
        }
        return (
            <FieldInstance label={this.props.context.translations["Standard.Number"] + "*"} noHover={true}>
                <IsNumericTextBox {...props} />
            </FieldInstance>
        );
    }

    private _createNameTextBox = () => {
        let props: TextBoxProps = this._factory.getDefaultTextBoxProps();
        props.value = Helper.getValueOrDefault(this.state.selectedEntity.Name, "");

        props.field.maxLength = 33;
        props.onChange = (field: { model: string, name: string }, value: any) => {
            let newEntity = this.state.selectedEntity;
            newEntity.Name = value;
            this.setState({ selectedEntity: newEntity });
        }
        return (
            <FieldInstance label={this.props.context.translations["Standard.Name"]} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _createTranslationLabel = () => {
        if (!this.state.selectedEntity.IsNew) {
            const labelStyle: React.CSSProperties = {
                cursor: "pointer",
                textDecoration: "Underline"
            }
            const divStyle: React.CSSProperties = {
                display: "flex",
                justifyContent: "flex-end",
                fontSize: "10px",
                marginTop: "2px"
            }
            return (
                <FieldInstance noLabel={true}>
                    <div style={divStyle}>
                        <label
                            style={labelStyle}
                            onClick={this._openTranslationsDialog}>{this.props.context.translations["WebSMS.GeneralSettings.UebersetzungenBearbeiten"]}
                        </label>
                    </div>
                </FieldInstance>);
        } else {
            return <></>;
        }
    }

    private _openTranslationsDialog = () => {
        this._editTranslationsRef.openDialog(this.state.selectedEntity.IsRowId, 205, "value_0", this.state.selectedEntity.GermanName);
    }

    private _createDropDownList = () => {
        let props = this._factory.getDefaultDropDownProps();
        props.value = this.state.selectedEntity.ReferenceToMainGroup;
        props.required = this._machineDependence;
        props.field.dataSourceUrl = "MachineSettings/GetOGrNrs";
        props.field.dataTextField = "Maogruppe";
        props.field.dataValueField = "Maogrnr";
        props.onChange = (field: { model: string, name: string }, value: any) => {
            let newEntity = this.state.selectedEntity;
            newEntity.ReferenceToMainGroup = value;
            this.setState({ selectedEntity: newEntity });
        }
        props.onDataLoaded = (field: { model: string }, data: any) => {

        }
        return (
            <FieldInstance label={this.props.context.translations["Field.Maschine.maogrnr"]} noHover={true}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private _closeDialog = () => {
        this.setState({ dialogOpen: false });
    }

    private _saveEntity = () => {
        let url = "MachineSettings/SaveMaschGroup";
        HTTPService.post<JsonResultClass>(url, this.state.selectedEntity)
            .then(result => {
                if (result.Code != 0) {
                    NotificationHelper.showErrorMessage(result.Message);
                }
                this._getGridData();
            });
    }

    private _deleteEntity = (dataItem: MaschGroup) => {
        DialogHelper.confirm(Config.translations.deleteMessage).then(isOk => {
            if (isOk) {
                let url = "MachineSettings/DeleteMaschGroup";
                HTTPService.post<JsonResultClass>(url, dataItem)
                    .then(result => {
                        this._getGridData();
                    });
            }
        });
    }
    
    private _getGridData = () => {
        let url = "MachineSettings/GetMachineGroups";
        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {
                    this._nextMaGrNr = result.AdditionalData.NextId;
                    this._machineDependence = result.AdditionalData.MachineDependence;
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: true });
        let grid = (
            <Grid data={this.state.gridData} options={this.props.context.editMaschineGroupGridOptions} id="GeneralSettings_MachineGroups"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} />
        );
        return (
            <div style={{ height:"300px" }}>
                {grid}
            </div>    
            )
        }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: MaschGroup) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this.setState({ dialogOpen: true, selectedEntity: dataItem });
                break;
            case (ToolBarStandardButtonType.NEW):
                this.setState({
                    dialogOpen: true, selectedEntity: {
                        Id: this._nextMaGrNr,
                        IsNew: true,
                        Name: "",
                        GermanName: ""
                    }
                });
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._deleteEntity(dataItem);
                break;
        }
    }

    componentDidMount() {
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};

interface EditMachineGroupProps {
    context: ContextGeneralSettingsApp;
}

interface EditMachineGroupState {
    gridData: MaschGroup[];
    dialogOpen: boolean;
    selectedEntity: MaschGroup;
}

interface MaschGroup{
    Id: number;
    Name: string;
    IsNew: boolean;
    IsRowId?: number;
    ReferenceToMainGroup?: number;
    RefernecedMainGroupName?: string;
    GermanName: string;
}



